import { createContext } from "react";

const customersContext = createContext();

export default customersContext;